import { deselectCalendarDay } from 'actions/calendar_day'
import { clearCalendar } from 'actions/calendar'

export const navigateBack = (match) => (dispatch, _, { history }) => {
  const search = window.location.search
  const { params } = match

  dispatch(clearCalendar())
  switch (match.path) {
    case '/reschedulings/:inviteeUuid/:spotStartTime':
      dispatch(deselectCalendarDay())
      return history.push(`/reschedulings/${params.inviteeUuid}`)
    case '/s/:singleUseSlug/:spotStartTime':
      dispatch(deselectCalendarDay())
      return history.push(`/s/${params.singleUseSlug}${search}`)
    case '/b/:profileSlug/:eventTypeSlug/:spotStartTime':
      return history.push(`/b/${params.profileSlug}/${params.eventTypeSlug}${search}`)
    case '/d/:linkUid/:eventTypeName/:spotStartTime':
      dispatch(deselectCalendarDay())
      return history.push(`/d/${params.linkUid}/${params.eventTypeName}${search}`)
    case '/c/:eventTypeUuid/:spotStartTime':
      dispatch(deselectCalendarDay())
      return history.push(`/c/${params.eventTypeUuid}${search}`)
    case '/:profileSlug/:eventTypeSlug/:spotStartTime':
      dispatch(deselectCalendarDay())
      return history.push(`/${params.profileSlug}/${params.eventTypeSlug}${search}`)
    default:
      return undefined
  }
}
